export default __webpack_public_path__ + "static/media/getting_started.cc805a44.svg";